// styles
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
// types
import { FullReservation, ReservationPaymentList } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import removeTimezone from "../../../utils/removeTimezone";
import { BsEyeFill } from "react-icons/bs";
import { BiListUl } from "react-icons/bi";

export default function List({data}: {data: ReservationPaymentList[]}) {
    const { setReservationData, setCreatePaymentResId, setViewPaymentsData, setCreatePaymentGroupId } = useAdmin()
    return (
        <>
        <Main>
            <TableWrapper>
                <Table>
                    <thead>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Passenger</th>
                        <th>Order ID</th>
                        <th>Tour ID</th>
                        <th>Price</th>
                        <th>Tickets</th>
                        <th style={{width: '50px'}}>View</th>
                        <th style={{width: '70px'}}>Payment</th>
                    </thead>
                    <tbody>
                        {
                            data.map((item) => {
                                const group_passengers_base = item.type === 'group' ? item.reservations.map(r => r.passenger) : []
                                // prevent duplicated passengers in group reservations
                                const passengers = item.type === 'group' ? 
                                group_passengers_base.filter((passenger, index, self) =>
                                    index === self.findIndex((p) => (
                                        p.id === passenger.id
                                    ))
                                ) : [item.passenger]

                                const reservation_tours = item.type === 'group' ?
                                item?.reservations.filter((res, index, self) =>
                                    index === self.findIndex((r) => (
                                        r.tour_id === res.tour_id
                                    ))
                                ).map(r => r.tour_id) : [item.tour_id]

                                const price = item.type === 'group' ?
                                item.reservations.map(r => r.price).reduce((a,b) => a + b, 0)
                                : item.price
                                
                                const tickets = item.type === 'group' ?
                                item.reservations.map(r => r.tickets).reduce((a,b) => a + b, 0)
                                : item.tickets

                                return (
                                    <tr>
                                        <td>{removeTimezone(item.reservation_date || item.reservations[0].reservation_date)}</td>
                                        <td>{item.type}</td>
                                        <td>{passengers[0].name}</td>
                                        <td>{item.group_id || item.id}</td>
                                        <td>{reservation_tours.map(r => <>{r}<br/></>)}</td>
                                        <td>{price}</td>
                                        <td>{tickets}</td>
                                        <td>
                                            <button
                                            onClick={() => {
                                                setReservationData(item)
                                            }}
                                            className="select">
                                                <BsEyeFill/>
                                            </button>
                                        </td>
                                        <td>
                                            <button className="select"
                                            onClick={() => {
                                                if (item.type === 'group') {
                                                    setCreatePaymentGroupId(item.group_id)
                                                } else {
                                                    setCreatePaymentResId(item.id)
                                                }
                                                setViewPaymentsData(item.payments)
                                            }}
                                            >
                                                <BiListUl/>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </TableWrapper>
        </Main>
        </>
    )
}

const Main = styled.div`
display: flex;
flex-direction: column;
gap: 15px;
width: 90%;
margin: auto;
margin-top: 15px;
max-height: calc(80vh - 90px);
${mobile({
    width: '100%'
})}
overflow: unset;
.sale {
    background-color: ${props => props.theme.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
        box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
        transform: translateY(-3px);
    }
    .header {
        .name {
            flex: 1;
            text-align: center;
        }
        .actions {
            height: 100%;
            display: flex;
            gap: 5px;
            padding: 5px;
            button {
                height: 100%;
                width: 50px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                color: ${props => props.theme.white};
            }
            button.traspax {
                background-color: ${props => props.theme.blue};
            }
            button.details {
                background-color: ${props => props.theme.yellowDark};
            }
            button.assign {
                background-color: ${props => props.theme.lightGreen};
            }
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px 10px 0 0;
        position: relative;
        height: 40px;
        background-color: ${props => props.theme.black};
        color: ${props => props.theme.white};
    }
}
`

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 500px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    > button {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
            }
    }
    >button.selected-all {
        background-color: ${props => props.theme.yellowDark};
    }
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #000;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`